import UserProfile from "../../../../Models/UserProfile";
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface UserState {
    isLoggedIn: boolean,
    tokenAPI: string,
    sessionID: string,
    userProfile: UserProfile | undefined,
}

// Define the initial state using that type
const initialState: UserState = {
    isLoggedIn: false,
    tokenAPI: "",
    sessionID: "",
    userProfile: undefined,
}

export const userSlice = createSlice({
    name: 'user',
      // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        login: (state: any, action: PayloadAction<{tokenAPI: string, userProfile: UserProfile | undefined, sessionId: string}>) => {
            state.isLoggedIn = true
            state.tokenAPI = action.payload.tokenAPI
            state.sessionID = action.payload.sessionId
            state.userProfile = action.payload.userProfile
        },
        logout: (state: any) => {
            state.isLoggedIn = false
            state.tokenAPI = ""
            state.sessionID = ""
            state.userProfile = undefined
        },
        updateUserProfile: (state: any, action: PayloadAction<UserProfile>) => {
            state.userProfile = action.payload
        },
        updateTokenAPI: (state: any, action: PayloadAction<string>) => {
            state.tokenAPI = action.payload
        }
    }
})

export const { 
    login,
    logout,
    updateUserProfile,
    updateTokenAPI
} = userSlice.actions

// Other code such as selectors can use the imported `RootState` type
// export const selectIsLoggedIn = (state: RootState) => state.user.isLoggedIn

export default userSlice.reducer